import { render } from "./CustDataPetTableRow.vue?vue&type=template&id=598d352a&scoped=true&ts=true"
import script from "./CustDataPetTableRow.vue?vue&type=script&lang=ts"
export * from "./CustDataPetTableRow.vue?vue&type=script&lang=ts"

import "./CustDataPetTableRow.vue?vue&type=style&index=0&id=598d352a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598d352a"]])

export default __exports__